/**
 * Máximo de unidades por SKU en el carrito (suma todas las líneas: Boleta, Guía, catálogo).
 * Aplica en ficha de producto, carro lateral y página de carrito.
 */
(function () {
  if (window.FarmexCartSkuLimit) {
    return;
  }
  var MAX_PER_SKU = 10;
  var origFetchForSync = window.fetch.bind(window);

  function normalizeSku(sku) {
    return String(sku == null ? '' : sku).trim();
  }

  function escapeHtml(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getQuantityInputForLine(lineIndex) {
    return (
      document.getElementById('Quantity-' + lineIndex) ||
      document.getElementById('Drawer-quantity-' + lineIndex)
    );
  }

  function getProductDisplayNameForLine(lineIndex) {
    var input = getQuantityInputForLine(lineIndex);
    if (input) {
      var fromData = (input.dataset.cartLineTitle || '').trim();
      if (fromData) {
        return fromData;
      }
    }
    var row =
      document.getElementById('CartItem-' + lineIndex) ||
      document.getElementById('CartDrawer-Item-' + lineIndex);
    if (row) {
      var nameEl = row.querySelector('.cart-item__name');
      if (nameEl && nameEl.textContent) {
        return nameEl.textContent.trim();
      }
    }
    return '';
  }

  function getProductDisplayNameForSku(sku) {
    var normalized = normalizeSku(sku);
    if (!normalized) {
      return '';
    }
    var found = '';
    document.querySelectorAll('.quantity__input[data-cart-line-sku]').forEach(function (input) {
      if (found) {
        return;
      }
      if (normalizeSku(input.dataset.cartLineSku) !== normalized) {
        return;
      }
      var title = (input.dataset.cartLineTitle || '').trim();
      if (title) {
        found = title;
        return;
      }
      var row = input.closest('.cart-item, tr.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');
      if (row) {
        var nameEl = row.querySelector('.cart-item__name');
        if (nameEl && nameEl.textContent) {
          found = nameEl.textContent.trim();
        }
      }
    });
    return found;
  }

  function getProductLabel(lineIndex, sku) {
    var name = !isNaN(parseInt(lineIndex, 10)) ? getProductDisplayNameForLine(lineIndex) : '';
    if (!name && sku) {
      name = getProductDisplayNameForSku(sku);
    }
    return name || 'este producto';
  }

  function getTotalsBySku(excludeLineIndex) {
    var totals = {};
    document.querySelectorAll('.quantity__input[data-cart-line-sku]').forEach(function (input) {
      var line = parseInt(input.dataset.index, 10);
      if (!isNaN(excludeLineIndex) && line === excludeLineIndex) {
        return;
      }
      var sku = normalizeSku(input.dataset.cartLineSku);
      if (!sku) {
        return;
      }
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) {
        q = 0;
      }
      totals[sku] = (totals[sku] || 0) + q;
    });
    return totals;
  }

  function getSkuTotalsFromCartItems(items) {
    var totals = {};
    (items || []).forEach(function (item) {
      var sku = normalizeSku(item.sku);
      if (!sku) {
        sku = 'variant:' + String(item.variant_id || item.id || '');
      }
      var q = parseInt(item.quantity, 10);
      if (isNaN(q) || q < 0) {
        q = 0;
      }
      totals[sku] = (totals[sku] || 0) + q;
    });
    return totals;
  }

  function getSkuForLine(lineIndex) {
    var input = getQuantityInputForLine(lineIndex);
    return input ? normalizeSku(input.dataset.cartLineSku) : '';
  }

  function getMaxAllowedForLine(lineIndex) {
    var sku = getSkuForLine(lineIndex);
    if (!sku) {
      return MAX_PER_SKU;
    }
    var totals = getTotalsBySku(lineIndex);
    var other = totals[sku] || 0;
    return Math.max(0, MAX_PER_SKU - other);
  }

  function wouldExceedSkuLimit(lineIndex, newQuantity) {
    var sku = getSkuForLine(lineIndex);
    if (!sku) {
      return parseInt(newQuantity, 10) > MAX_PER_SKU;
    }
    var qty = parseInt(newQuantity, 10);
    if (isNaN(qty) || qty < 0) {
      qty = 0;
    }
    if (qty === 0) {
      return false;
    }
    var totals = getTotalsBySku(lineIndex);
    return (totals[sku] || 0) + qty > MAX_PER_SKU;
  }

  function ensureLimitModal() {
    var modal = document.getElementById('maxQtyModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'maxQtyModal';
      modal.className = 'qty-modal';
      modal.innerHTML =
        '<div class="qty-modal__content">' +
        '<h3>Cantidad máxima</h3>' +
        '<p>Por este producto solo puedes llevar ' +
        MAX_PER_SKU +
        ' unidades en total</p>' +
        '<button type="button" id="closeQtyModal" class="qty-modal__btn">Entendido</button>' +
        '</div>';
    }
    if (!document.getElementById('farmex-qty-modal-styles')) {
      var style = document.createElement('style');
      style.id = 'farmex-qty-modal-styles';
      style.textContent =
        '.qty-modal{position:fixed;inset:0;background:rgba(0,0,0,.55);display:none;align-items:center;justify-content:center;z-index:100050 !important}' +
        '.qty-modal.active{display:flex}' +
        '.qty-modal__content{background:#fff;padding:24px;max-width:360px;width:90%;border-radius:12px;text-align:center;box-shadow:0 20px 40px rgba(0,0,0,.2);position:relative;z-index:100051}' +
        '.qty-modal__content h3{margin:0 0 12px;font-size:1.25rem}' +
        '.qty-modal__content p{margin:0 0 20px;line-height:1.4}' +
        '.qty-modal__btn{background:#000;color:#fff;border:0;border-radius:8px;padding:10px 20px;cursor:pointer;font-weight:600}';
      document.head.appendChild(style);
    }
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    if (!modal.dataset.farmexCloseBound) {
      modal.dataset.farmexCloseBound = '1';
      var closeBtn = modal.querySelector('#closeQtyModal');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          modal.classList.remove('active');
        });
      }
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.classList.remove('active');
        }
      });
    }
    return modal;
  }

  function showLimitModal() {
    var modal = ensureLimitModal();
    var p = modal.querySelector('p');
    if (p) {
      p.textContent = 'Por este producto solo puedes llevar ' + MAX_PER_SKU + ' unidades en total';
    }
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.style.zIndex = '100050';
    modal.classList.add('active');
  }

  function clampQuantityInput(lineIndex) {
    var input = getQuantityInputForLine(lineIndex);
    if (!input) {
      return;
    }
    var maxAllowed = getMaxAllowedForLine(lineIndex);
    var min = parseInt(input.min, 10);
    if (isNaN(min) || min < 0) {
      min = 0;
    }
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < min) {
      value = min;
    }
    if (maxAllowed <= 0 && value > 0) {
      value = Math.max(min, 0);
    } else if (value > maxAllowed) {
      value = Math.max(min, maxAllowed);
    }
    input.value = value;
    input.setAttribute('value', String(value));
    if (maxAllowed >= 0) {
      input.max = Math.max(maxAllowed, min);
      input.setAttribute('data-max', String(Math.max(maxAllowed, min)));
    }
  }

  function clampAnyQuantityInput(input) {
    if (!input) {
      return false;
    }
    var line = parseInt(input.dataset.index, 10);
    var maxAttr = parseInt(input.max || input.getAttribute('data-max'), 10);
    var min = parseInt(input.min, 10);
    if (isNaN(min) || min < 0) {
      min = 1;
    }
    var value = parseInt(input.value, 10);
    var changed = false;
    var maxAllowed = maxAttr;

    if (!isNaN(line) && input.dataset.cartLineSku) {
      maxAllowed = getMaxAllowedForLine(line);
    } else if (isNaN(maxAllowed)) {
      maxAllowed = MAX_PER_SKU;
    }
    maxAllowed = Math.min(maxAllowed, MAX_PER_SKU);

    if (isNaN(value) || value < min) {
      value = min;
      changed = true;
    }
    if (value > maxAllowed) {
      value = Math.max(min, maxAllowed);
      changed = true;
      showLimitModal(isNaN(line) ? null : line, maxAllowed, (input.dataset.cartLineTitle || '').trim());
    }

    input.value = value;
    input.max = Math.max(maxAllowed, min);
    input.setAttribute('data-max', String(Math.max(maxAllowed, min)));
    return changed;
  }

  function refreshAllQuantityMaxAttributes() {
    document.querySelectorAll('.quantity__input[data-cart-line-sku]').forEach(function (input) {
      var line = parseInt(input.dataset.index, 10);
      if (isNaN(line)) {
        return;
      }
      var maxAllowed = getMaxAllowedForLine(line);
      var min = parseInt(input.min, 10);
      if (isNaN(min) || min < 0) {
        min = 0;
      }
      var capped = Math.max(maxAllowed, min);
      input.max = capped;
      input.setAttribute('data-max', String(capped));
      var value = parseInt(input.value, 10);
      if (!isNaN(value) && value > maxAllowed && maxAllowed >= min) {
        input.value = Math.max(min, maxAllowed);
      }
    });

    document.querySelectorAll('.quantity__input[name="quantity"]').forEach(function (input) {
      var maxAttr = parseInt(input.max || input.getAttribute('data-max'), 10);
      if (isNaN(maxAttr) || maxAttr > MAX_PER_SKU) {
        input.max = MAX_PER_SKU;
        input.setAttribute('data-max', String(MAX_PER_SKU));
      }
      var value = parseInt(input.value, 10);
      var max = parseInt(input.max, 10);
      if (!isNaN(value) && !isNaN(max) && value > max) {
        input.value = max;
      }
    });
  }

  function validateBeforeCartChange(lineIndex, quantity) {
    var line = parseInt(lineIndex, 10);
    var qty = parseInt(quantity, 10);
    if (isNaN(line) || isNaN(qty) || qty <= 0) {
      return null;
    }
    if (!wouldExceedSkuLimit(line, qty)) {
      return null;
    }
    var sku = getSkuForLine(line);
    var maxAllowed = getMaxAllowedForLine(line);
    var productLabel = getProductLabel(line, sku);
    clampQuantityInput(line);
    showLimitModal(line, maxAllowed);
    return {
      line: line,
      sku: sku,
      maxAllowed: maxAllowed,
      message:
        'Máximo ' +
        MAX_PER_SKU +
        ' unidades de ' +
        productLabel +
        ' en total en el carrito.',
    };
  }

  function fetchCart() {
    return origFetchForSync('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function resolveSkuForVariant(cart, variantId, fallbackSku) {
    var id = String(variantId || '');
    var found = '';
    (cart.items || []).forEach(function (item) {
      if (found) {
        return;
      }
      if (String(item.variant_id) === id) {
        found = normalizeSku(item.sku);
      }
    });
    return found || normalizeSku(fallbackSku) || (id ? 'variant:' + id : '');
  }

  function validateBeforeAdd(itemsToAdd, cart, productLabel) {
    var totals = getSkuTotalsFromCartItems(cart && cart.items);
    var blocked = null;
    (itemsToAdd || []).forEach(function (entry) {
      if (blocked) {
        return;
      }
      var qty = parseInt(entry.quantity, 10);
      if (isNaN(qty) || qty <= 0) {
        return;
      }
      var sku = resolveSkuForVariant(cart, entry.id || entry.variant_id, entry.sku);
      var current = totals[sku] || 0;
      if (current + qty > MAX_PER_SKU) {
        var maxAllowed = Math.max(0, MAX_PER_SKU - current);
        blocked = {
          sku: sku,
          maxAllowed: maxAllowed,
          current: current,
          message:
            'Máximo ' +
            MAX_PER_SKU +
            ' unidades de ' +
            (productLabel || 'este producto') +
            ' en total en el carrito.',
        };
        showLimitModal(null, maxAllowed, productLabel);
      } else {
        totals[sku] = current + qty;
      }
    });
    return blocked;
  }

  function parseAddPayload(init) {
    if (!init || !init.body) {
      return null;
    }
    var body = init.body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var items = [];
      if (body.get('id')) {
        items.push({
          id: body.get('id'),
          quantity: body.get('quantity') || 1,
          sku: body.get('sku') || '',
        });
      }
      var indexed = {};
      body.forEach(function (value, key) {
        var match = key.match(/^items\[(\d+)\]\[(id|quantity|sku)\]$/);
        if (match) {
          var idx = match[1];
          indexed[idx] = indexed[idx] || {};
          indexed[idx][match[2]] = value;
        }
      });
      Object.keys(indexed).forEach(function (k) {
        if (indexed[k].id) {
          items.push(indexed[k]);
        }
      });
      return items.length ? items : null;
    }
    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        if (parsed.items && Array.isArray(parsed.items)) {
          return parsed.items;
        }
        if (parsed.id) {
          return [{ id: parsed.id, quantity: parsed.quantity || 1, sku: parsed.sku || '' }];
        }
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function blockedAddResponse(message) {
    return Promise.resolve(
      new Response(
        JSON.stringify({
          status: 422,
          message: message,
          description: message,
          errors: message,
        }),
        {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        }
      )
    );
  }

  function bindQuantityInputGuards(root) {
    var scope = root || document;
    scope.querySelectorAll('.quantity__input').forEach(function (input) {
      if (input.dataset.farmexQtyGuardBound === '1') {
        return;
      }
      input.dataset.farmexQtyGuardBound = '1';
      input.addEventListener('change', function () {
        clampAnyQuantityInput(input);
      });
      input.addEventListener('blur', function () {
        clampAnyQuantityInput(input);
      });
    });
  }

  function enforceOverLimitInDom() {
    document.querySelectorAll('.quantity__input[data-cart-line-sku]').forEach(function (input) {
      var line = parseInt(input.dataset.index, 10);
      if (isNaN(line)) {
        return;
      }
      var maxAllowed = getMaxAllowedForLine(line);
      var value = parseInt(input.value, 10);
      if (!isNaN(value) && value > maxAllowed) {
        input.value = Math.max(0, maxAllowed);
      }
    });
  }

  function syncCartIfOverLimit() {
    if (window.__farmexSkuLimitSyncing) {
      return;
    }
    fetchCart()
      .then(function (cart) {
        var totals = getSkuTotalsFromCartItems(cart.items);
        var overSkus = Object.keys(totals).filter(function (sku) {
          return totals[sku] > MAX_PER_SKU;
        });
        if (!overSkus.length) {
          return null;
        }
        var remainingBySku = {};
        overSkus.forEach(function (sku) {
          remainingBySku[sku] = MAX_PER_SKU;
        });
        var updates = {};
        var changed = false;
        (cart.items || []).forEach(function (item) {
          var sku = normalizeSku(item.sku) || 'variant:' + String(item.variant_id || item.id || '');
          if (!remainingBySku.hasOwnProperty(sku)) {
            return;
          }
          var allowed = remainingBySku[sku];
          var qty = parseInt(item.quantity, 10) || 0;
          var next = Math.min(qty, allowed);
          remainingBySku[sku] = Math.max(0, allowed - next);
          if (next !== qty) {
            updates[item.key] = next;
            changed = true;
          }
        });
        if (!changed) {
          return null;
        }
        window.__farmexSkuLimitSyncing = true;
        return origFetchForSync('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        }).then(function (res) {
          return res.json();
        });
      })
      .then(function (updatedCart) {
        window.__farmexSkuLimitSyncing = false;
        if (!updatedCart) {
          return;
        }
        try {
          sessionStorage.setItem('farmexSkuLimitAdjusted', '1');
        } catch (e) {
          /* noop */
        }
        window.location.reload();
      })
      .catch(function () {
        window.__farmexSkuLimitSyncing = false;
      });
  }

  window.FarmexCartSkuLimit = {
    MAX_PER_SKU: MAX_PER_SKU,
    wouldExceedSkuLimit: wouldExceedSkuLimit,
    getMaxAllowedForLine: getMaxAllowedForLine,
    getProductLabel: getProductLabel,
    showLimitModal: showLimitModal,
    validateBeforeCartChange: validateBeforeCartChange,
    validateBeforeAdd: validateBeforeAdd,
    refreshAllQuantityMaxAttributes: refreshAllQuantityMaxAttributes,
    clampQuantityInput: clampQuantityInput,
    clampAnyQuantityInput: clampAnyQuantityInput,
    bindQuantityInputGuards: bindQuantityInputGuards,
    fetchCart: fetchCart,
  };

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    ensureLimitModal();
    refreshAllQuantityMaxAttributes();
    enforceOverLimitInDom();
    bindQuantityInputGuards(document);
    try {
      if (sessionStorage.getItem('farmexSkuLimitAdjusted') === '1') {
        sessionStorage.removeItem('farmexSkuLimitAdjusted');
        showLimitModal(null, 0, 'algunos productos');
      }
    } catch (e) {
      /* noop */
    }
    syncCartIfOverLimit();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    onReady(function () {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () {
          refreshAllQuantityMaxAttributes();
          bindQuantityInputGuards(document);
        }, 150);
      });
    });
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(function () {
      refreshAllQuantityMaxAttributes();
      bindQuantityInputGuards(document);
    }, 150);
  });

  (function patchCartFetch() {
    if (window.__farmexPatchCartChangeSkuLimit) {
      return;
    }
    window.__farmexPatchCartChangeSkuLimit = true;
    var origFetch = origFetchForSync;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isChange = /\/cart\/change(\.js)?(\?|$)/i.test(url);
      var isAdd = /\/cart\/add(\.js)?(\?|$)/i.test(url);

      if (isChange && init && init.body && typeof init.body === 'string') {
        try {
          var body = JSON.parse(init.body);
          if (body.line != null && body.quantity != null) {
            var blockedChange = validateBeforeCartChange(body.line, body.quantity);
            if (blockedChange) {
              return Promise.resolve(
                new Response(
                  JSON.stringify({
                    errors: blockedChange.message,
                  }),
                  {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                  }
                )
              );
            }
          }
        } catch (e) {
          /* noop */
        }
      }

      if (isAdd) {
        var itemsToAdd = parseAddPayload(init);
        if (itemsToAdd && itemsToAdd.length) {
          return fetchCart()
            .then(function (cart) {
              var label = '';
              try {
                var form =
                  document.querySelector('product-form form') ||
                  document.querySelector('form[action*="/cart/add"]');
                if (form) {
                  var titleEl = document.querySelector('h1.product__title, .product__title');
                  if (titleEl) {
                    label = titleEl.textContent.trim();
                  }
                }
              } catch (e2) {
                /* noop */
              }
              var blockedAdd = validateBeforeAdd(itemsToAdd, cart, label);
              if (blockedAdd) {
                return blockedAddResponse(blockedAdd.message);
              }
              return origFetch(input, init);
            })
            .then(function (res) {
              if (res && res.ok) {
                setTimeout(function () {
                  refreshAllQuantityMaxAttributes();
                  bindQuantityInputGuards(document);
                }, 150);
              }
              return res;
            });
        }
      }

      return origFetch(input, init).then(function (res) {
        if (res.ok && (isChange || isAdd)) {
          setTimeout(function () {
            refreshAllQuantityMaxAttributes();
            bindQuantityInputGuards(document);
          }, 150);
        }
        return res;
      });
    };
  })();
})();
